// extracted by mini-css-extract-plugin
export default {"mail-caution":"ReservationCompletionPage_mail-caution__aXetf"};